<template>
  <div class="page-container">
    <div>
      <Artist :list="artistList" :swiper="true"></Artist>
    </div>
    <div class="section">
      <Panel @change="changeType" :menu="typeList" :title="'大家拍'" :plain="false">
        <ProList :page="true" :pro-desc="true" :list="list" :countdown="true" @nextPageTarget="getProductByType" :nowtime="nowtime" :isend="isend"></ProList>
      </Panel>
    </div>
  </div>
</template>

<script>
import Panel from '../../components/panel.vue';
import Artist from '../../components/artist.vue';
import ProList from '../../components/prolist.vue';
import { Everybody } from '../../model/everybody.js';
let everybody = new Everybody();
export default {
  name: 'index',
  data() {
    return {
      pageIndex: 1,
      pageSize: 16,
      productType: '',
      orderNum: '', //1：人气，2：价格，3：结拍时间 默认空值
      orderType: 'asc', //降序：desc/升序：asc 默认：asc
      typeList: [], //作品分类
      options: false, //筛选框
      artistList: [],
      list: [], //作品列表
      nowtime: "",
      isend: false
    }
  },
  components: {
    Panel,
    Artist,
    ProList
  },
  methods: {
    getProductTypeList() {
      let _this = this;
      return new Promise(function (resolve, reject) {
        everybody.productTypeList({
          UnionId: _this.user ? _this.user.union_id : ""
        }).then((res) => {
          if (res.ProductType) {
            let type = [];
            //重新赋值为需要的数组
            res.ProductType.forEach((element) => {
              if (element.product_type === '全部') {
                _this.productType = element.id
              }
              type.push({ name: element.product_type, id: element.id })
            });
            _this.typeList = type
          }
          if (res.Author) {
            _this.artistList = res.Author
          }
          resolve()
        }, () => {
          reject()
        })
      })
    },
    getProductByType() {
      let _this = this;
      return new Promise(function (resolve, reject) {
        everybody.productByType({
          OrderNum: _this.orderNum,
          OrderType: _this.orderType,
          PageIndex: _this.pageIndex,
          PageSize: _this.pageSize,
          ProductType: _this.productType
        }).then((res) => {
          let list = res.data;
          _this.nowtime = res.NowTime
          if (list.length < _this.pageSize || list.length == 0) {
            _this.isend = true
          }
          _this.list = list.length > 0 ? _this.list.concat(list) : _this.list;
          _this.pageIndex++;
          resolve();
        }, (reason) => {
          reject(reason)
        })
      })
    },
    init() {
      let _this = this;
      return new Promise(function (resolve, reject) {
        _this.getProductTypeList().then(() => {
          //获取默认分类
          _this.typeList.forEach((element) => {
            if (element.name === '全部') {
              _this.productType = element.id
            }
          });
          if (_this.productType) {
            _this.getProductByType().then(() => {
              resolve();
            }, (reason) => {
              reject({
                StatusCode: 202,
                success: false,
                errorMessage: "获取列表失败" + reason
              })
            });
          } else {
            reject({
              StatusCode: 201,
              success: false,
              errorMessage: "没有默认分类，请联系管理员"
            })
          }
        }, () => {
          reject()
        });
      })
    },
    resetOptionStatus() {
      this.list = [];
      this.pageIndex = 1;
      this.isend = false;
      this.timer && clearInterval(this.timer);
      this.time = [];
      this.getProductByType();
    },
    changeType(index) { //切换作品类型
      let _this = this;
      _this.productType = _this.typeList[index].id
      _this.resetOptionStatus();
    }
  },
  created() {
    this.init().then(() => {
    }, (reason) => {
      this.$message.error(reason.errorMessage);
    })
  },
  destroyed() {
    clearInterval(this.timer);
  }
}
</script>
<style lang="scss" scoped>
.section {
  margin-top: 20px;
}
</style>